import { TUser } from 'src/app/project/modules/user/user.model';

const SITE_VIEW = 'site';
const OVERVIEW_VIEW = 'overview';

export type TSlowModalOpenReport = {
  url: string;
  view: typeof SITE_VIEW | typeof OVERVIEW_VIEW;
  workspaceId: string;
  pointId: string;
  userEmail: string;
  userId: string;
  accountId: string;
};

export const buildSlowModalOpenReport = ({
  url,
  overview,
  workspaceId,
  pointId,
  user,
}: {
  url: string;
  overview: boolean;
  workspaceId: string;
  pointId: string;
  user: TUser;
}): TSlowModalOpenReport => ({
  url,
  view: overview ? OVERVIEW_VIEW : SITE_VIEW,
  workspaceId: workspaceId ?? '',
  pointId,
  userEmail: user?.email ?? '',
  userId: user?.userId ?? '',
  accountId: user?.accountId ?? '',
});
